import api from '@/lib/api';
import { auth } from '@/lib/firebase';

export const actions = {
  async fetchModules() {
    try {
      const response = await api.get('/modules/');
    
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      
      throw error;
    }
  },

  async updateModule(_, { id, payload }) {
      const token = await auth.currentUser.getIdToken();
  
      try {
        const response = await api.put(`/modules/${id}`, 
          payload,
          { headers: { Authorization: `Bearer ${token}` }, }
        );
  
        return response.data;
      } catch (error) {
        if (error.response) {
          throw error.response.data;
        }
        throw error;
      }
    },
  
    async updateModuleStatus(_, payload) {
      const token = await auth.currentUser.getIdToken();
  
      try {
        const response = await api.put('/modules/status', 
          payload,
          { headers: { Authorization: `Bearer ${token}` }, }
        );
  
        return response.data;
      } catch (error) {
        if (error.response) {
          throw error.response.data;
        }
        throw error;
      }
    },
}

export default {
  namespaced: true,
  actions,
}